import React, { useState, useRef } from "react";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import "./betslip.css";
import toastr from "toastr";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setBets } from "../../store/Betslip/actions";
import { Twitter, Facebook, Whatsapp, Telegram } from "react-social-sharing";
import BookingCodeSheet from "../../components/Common/BookingCodeSheet";

import {
  getRegulatoryAndParameters,
  placeBetCall,
  getUserInfo,
  bookBetCall,
  axiosApi,
  getCashBalanceLogs,
  placeSingleBetCall,
} from "../../helpers/repository";
import startCase from "lodash/startCase";
import {
  getfreebetAmount,
  getUserBalance,
} from "../../components/Common/Utils/helpers";
import { APP_URL, currency, ERMC_API_KEY } from "../../helpers/constants";
import _ from "lodash";
import ReactModal from "react-modal";
import Iframe from "react-iframe";
import { showMessage } from "../../components/Common/Toaster";

// Build an odds map from any server odds format (array or keyed object)
const _buildOddsMap = (odds) => {
  const map = new Map();
  if (Array.isArray(odds)) {
    odds.forEach((o) => {
      if (o?._id) map.set(o._id, parseFloat(o.value));
    });
  } else if (odds && typeof odds === "object") {
    Object.entries(odds).forEach(([key, val]) => {
      if (typeof val === "object" && val !== null)
        map.set(val._id || key, parseFloat(val.value));
      else map.set(key, parseFloat(val));
    });
  }
  return map;
};

// Update Bets with oddChange/prevValue from new odds.
// `specialOffersMap` (optional) maps a BASE odd's _id -> its fresh
// special_market_offers array, when the caller's data source actually
// carries that (currently only the /v4/fixtures/{id}/show poll below).
// A 1UP/2UP odd's displayed `value` is the boosted price, not the base
// price in `newOddsMap` — comparing it against the base value always
// "detects a change" that never happened. When we have the fresh offers,
// re-derive the current boosted price and compare/update against that
// instead; when we don't, leave the special odd untouched rather than
// risk clobbering its boosted value with the base one.
const _applyOddChangesToBets = (bets, newOddsMap, specialOffersMap) => {
  return bets.map((bet) => ({
    ...bet,
    fixture_markets: bet.fixture_markets.map((market) => ({
      ...market,
      fixture_market_odds: (market.fixture_market_odds || []).map((odd) => {
        if (odd.is_special_market_odd) {
          const offers = specialOffersMap?.get(odd.base_odd_id);
          const offer = offers?.find(
            (o) => o.special_market_id === odd.special_market_id,
          );
          if (!offer) return odd;
          const newVal = parseFloat(offer.special_odd);
          const freshBaseVal = newOddsMap.get(odd.base_odd_id);
          if (isNaN(newVal)) return odd;
          const prevVal = parseFloat(odd.value);
          const direction =
            !isNaN(prevVal) && newVal !== prevVal
              ? newVal > prevVal
                ? "up"
                : "down"
              : null;
          return {
            ...odd,
            prevValue: direction ? prevVal : odd.prevValue,
            value: String(newVal),
            oddChange: direction,
            ...(freshBaseVal !== undefined && !isNaN(freshBaseVal)
              ? { base_odd_value: String(freshBaseVal) }
              : {}),
          };
        }
        const newVal = newOddsMap.get(odd._id);
        if (newVal !== undefined && !isNaN(newVal)) {
          const prevVal = parseFloat(odd.value);
          const direction =
            !isNaN(prevVal) && newVal !== prevVal
              ? newVal > prevVal
                ? "up"
                : "down"
              : null;
          return {
            ...odd,
            prevValue: direction ? prevVal : odd.prevValue,
            value: String(newVal),
            oddChange: direction,
          };
        }
        return odd;
      }),
    })),
  }));
};

const QUICK_STAKES = [500, 1000, 5000, 10000];
const currencySymbol = "₦";

function BetSlip(props) {
  const isLoggedIn = sessionStorage.getItem("token") ? true : false;
  let dispatch = useDispatch();
  let history = useHistory();
  const query = new URLSearchParams(props.location.search);
  const booking_code = query.get("booking_code");

  const Bets = useSelector((state) => state?.Betslip?.bets ?? []);
  const [totalOdds, setTotalOdds] = useState(0);
  const [stake, setStake] = useState(0);
  const [oldStake, setOldStake] = useState(0);
  const [exciseTaxPercentage, setExciseTaxPercentage] = useState(null);
  const [exciseTax, setExciseTax] = useState(0);
  const [WHTPercentage, setWHTPercentage] = useState(null);
  const [bonusPercentage, setBonusPercentage] = useState(null);
  const [WHT, setWHT] = useState(0);
  const [WIN, setWIN] = useState(0);
  const [minimumBet, setMinimumBet] = useState(null);
  const [maximumBet, setMaximumBet] = useState(null);
  const [freebetMinimumOdds, setFreebetMinimumOdds] = useState(null);
  const [freebetMaximumOdds, setFreebetMaximumOdds] = useState(null);
  const [freebetMinimumMatches, setFreebetMinimumMatches] = useState(null);
  const [maximumPayout, setMaximumPayout] = useState(null);
  const [maximumBonusPayout, setMaximumBonusPayout] = useState(null);
  const [minimumOdds, setMinimumOdds] = useState(null);
  const [bonusMinimumOdds, setBonusMinimumOdds] = useState(null);
  const [notApplicableOdds, setNotApplicableOdds] = useState(0);
  const [userBalance, setUserBalance] = useState(0);
  const [firstDeposit, setFirstDeposit] = useState(0);
  const [bonusAmount, setBonusAmount] = useState(0);
  const [useBonus, setUseBonus] = useState(false);
  const [canUseBonus, setCanUseBonus] = useState(false);
  const [minMatch, setMinMatch] = useState(1);
  const [isBonusActive, setIsBonusActive] = useState(0);
  const [isBalanceLess, setIsBalanceLess] = useState(false);
  const [odds, setOdds] = useState(null);
  const [totalOddNew, setTotalOddNew] = useState(0);
  const [multiBonusPercent, setMultiBonusPercent] = useState(0);
  const [multiBonusAmount, setMultiBonusAmount] = useState(0);
  const [signupBonus, setSignupBonus] = useState(0);

  const [keepBet, setKeepBet] = useState(false);
  const [addMoreCount, setAddMoreCount] = useState(null);
  const [bonusPercent, setBonusPercent] = useState(null);
  const [selectedPercent, setSelectedPercent] = useState(0);
  const [selectedBonus, setSelectedBonus] = useState(0);
  const [checkLiveSelected, setcheckLiveSelected] = useState(true);
  const [loading, setLoading] = useState(null);
  const [loadingBook, setloadingBook] = useState(null);
  const [isAllPrematch, setIsAllPrematch] = useState(false);
  const [openModel, setModelOpen] = useState(false);
  const [openBookModel, setBookModelOpen] = useState(false);
  const [cashLogStatus, setCashLogStatus] = useState(false);
  const [bookingId, setBookingId] = useState(booking_code);
  const [note, setNote] = useState("");
  const [searchBookingCode, setSearchBookingCode] = useState(booking_code);
  const [mode, setMode] = useState("multiple");
  const [bonusError, setBonusError] = useState("");
  const [bonusType, setBonusType] = useState("");
  const [freebet, setfreebet] = useState(0);
  const [showFreebetMsg, setshowFreebetMsg] = useState(false);
  const [useFreeBet, setuseFreeBet] = useState(false);
  const [oddsAcceptMode, setOddsAcceptMode] = useState("higher");
  const [hasAcceptedNewOdds, setHasAcceptedNewOdds] = useState(false);
  const [singleStakes, setSingleStakes] = useState({});
  const [bookingSheetOpen, setBookingSheetOpen] = useState(false);

  const copied = () => {
    navigator.clipboard.writeText(bookingId);
    $(".apply-p1")
      .empty()
      .show()
      .text("Copied")
      .css({
        color: "white",
        "background-color": "#272727",
        "text-align": "center",
        "border-radius": "2px",
        width: "max-content",
        position: "absolute",
        "z-index": "1",
        padding: "8px 9px 8px 12px",
        margin: "-9px 0px 0px 5px",
        fontSize: "10px",
      })
      .delay(2000)
      .fadeOut(300);
  };
  const bburl = `${APP_URL}/betSlip?booking_code=${bookingId}`;
  const CountDown = ({ hours = 0, minutes = 0, seconds = 0 }) => {
    const [over, setOver] = useState(false);
    const [[h, m, s], setTime] = useState([hours, minutes, seconds]);

    const tick = () => {
      if (over) return;
      if (h === 0 && m === 0 && s === 0) {
        setOver(true);
        setModelOpen(false);
        setLoading(0);
        setloadingBook(0);
      } else if (m === 0 && s === 0) {
        setTime([h - 1, 59, 59]);
      } else if (s == 0) {
        setTime([h, m - 1, 59]);
      } else {
        setTime([h, m, s - 1]);
      }
    };

    useEffect(() => {
      const timerID = setInterval(() => tick(), 1000);
      return () => clearInterval(timerID);
    });

    return (
      <div style={{ "text-align": "center", "margin-top": "10px" }}>
        <h6 style={{ color: "#ff0000" }}>{`${h.toString().padStart(2, "0")}:${m
          .toString()
          .padStart(2, "0")}:${s.toString().padStart(2, "0")}`}</h6>
      </div>
    );
  };
  useEffect(() => {
    const storedBets = localStorage.getItem("betsplace");
    if (storedBets) {
      dispatch(setBets(JSON.parse(storedBets)));
    }
  }, [dispatch]);

  useEffect(() => {
    const bookDetail = JSON.parse(localStorage.getItem("book_bet_detail"));
    if (bookDetail) setBookingId(bookDetail?.booking_id);
  }, [bookingId]);

  useEffect(() => {
    localStorage.setItem("betsplace", JSON.stringify(Bets));
    let BetOdd = Bets.map((bet) => {
      return _getPlacedBet(bet.fixture_markets);
    }).map((bet) => {
      let sendBet = {};
      sendBet._id = bet.is_special_market_odd ? bet.base_odd_id : bet._id;
      return sendBet;
    });
    const bookDetail = JSON.parse(localStorage.getItem("book_bet_detail"));
    if (BetOdd?.length == bookDetail?.odds?.length) {
      const obj1Ids = BetOdd.map((item) => item._id);
      const obj2Ids = bookDetail?.odds.map((item) => item._id);
      const areAllIdsSame =
        obj1Ids.every((id) => obj2Ids.includes(id)) &&
        obj2Ids.every((id) => obj1Ids.includes(id));
      if (areAllIdsSame) {
        setSearchBookingCode(bookDetail?.booking_id);
        setBookingId(bookDetail?.booking_id);
      }
    } else {
      setSearchBookingCode(null);
      setBookingId(null);
    }
  }, [Bets]);

  useEffect(() => {
    if (freebet > 0) {
      if (parseFloat(stake) == freebet) {
        setshowFreebetMsg(false);
        setuseFreeBet(true);
      } else {
        setshowFreebetMsg(true);
        setuseFreeBet(false);
      }
    }
  }, [stake]);

  useEffect(() => {
    getRegulatoryAndParameters(handleSuccess);
    if (isLoggedIn) {
      getCashBalanceLogs(handleEndUserLogSuccess);
      getUserInfo(handleSuccessGotUser, errorUserInfoCall);
      setUserBalance(getUserBalance());
      setfreebet(getfreebetAmount());
    }
  }, []);

  // Poll for odds changes every 15s so the slip never goes stale (parity with mobile)
  const pollRef = useRef(null);
  const betsRef = useRef(Bets);
  betsRef.current = Bets;

  useEffect(() => {
    if (pollRef.current) clearInterval(pollRef.current);
    if (!Bets.length) return;

    const fetchLatestOdds = async () => {
      const currentBets = betsRef.current;
      if (!currentBets.length) return;
      try {
        const fixtureIds = currentBets.map((b) => b._id);
        const responses = await Promise.allSettled(
          fixtureIds.map((id) => axiosApi.get(`/v4/fixtures/${id}/show`)),
        );
        const oddsMap = new Map();
        // Keyed by the BASE odd's _id -> its fresh special_market_offers
        // array, so 1UP/2UP bets can be compared against their current
        // boosted price instead of the base price in `oddsMap`.
        const specialOffersMap = new Map();
        responses.forEach((result) => {
          if (result.status !== "fulfilled") return;
          const fixture = result.value?.data?.data;
          if (!fixture?.fixture_markets) return;
          for (const market of fixture.fixture_markets) {
            for (const odd of market.fixture_market_odds || []) {
              if (odd?._id && odd?.value != null && odd.value !== "OFF") {
                oddsMap.set(odd._id, parseFloat(odd.value));
              }
              if (odd?._id && Array.isArray(odd.special_market_offers)) {
                specialOffersMap.set(odd._id, odd.special_market_offers);
              }
            }
          }
        });
        if (!oddsMap.size) return;
        let hasChanges = false;
        for (const bet of currentBets) {
          const sel = _getPlacedBet(bet.fixture_markets);
          if (!sel?._id) continue;
          if (sel.is_special_market_odd) {
            const offers = specialOffersMap.get(sel.base_odd_id);
            const offer = offers?.find(
              (o) => o.special_market_id === sel.special_market_id,
            );
            const newVal = offer ? parseFloat(offer.special_odd) : undefined;
            if (
              newVal !== undefined &&
              !isNaN(newVal) &&
              newVal !== parseFloat(sel.value)
            ) {
              hasChanges = true;
              break;
            }
            continue;
          }
          const newVal = oddsMap.get(sel._id);
          if (
            newVal !== undefined &&
            !isNaN(newVal) &&
            newVal !== parseFloat(sel.value)
          ) {
            hasChanges = true;
            break;
          }
        }
        if (hasChanges) {
          dispatch(
            setBets(
              _applyOddChangesToBets(currentBets, oddsMap, specialOffersMap),
            ),
          );
          setHasAcceptedNewOdds(false);
        }
      } catch (e) {
        // ignore polling errors
      }
    };

    const initialTimeout = setTimeout(fetchLatestOdds, 5000);
    pollRef.current = setInterval(fetchLatestOdds, 15000);
    return () => {
      clearTimeout(initialTimeout);
      if (pollRef.current) clearInterval(pollRef.current);
    };
  }, [Bets.length]);

  const errorUserInfoCall = (e) => {
    showMessage(e);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
    },
  };
  const customBetStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
      backgroundColor: "#272727",
      color: "white",
      padding: "0px",
    },
  };
  const _handleSubmitBet = () => {
    setLoading(1);
    if (!isLoggedIn) {
      history.push(`/login`);
      return;
    }
    if (parseFloat(stake) < minimumBet) {
      toastr.error(`Stake should be Greater Or Equal to ${minimumBet}`);
      return;
    } else if (parseFloat(stake) > maximumBet) {
      toastr.error(`Stake should be Less Or Equal to ${maximumBet}`);
      return;
    }
    var live_array = [];
    let odds = Bets.map((bet) => {
      return _getPlacedBet(bet.fixture_markets);
    }).map((bet) => {
      // let sendBet = {};
      // sendBet._id = bet._id;
      // sendBet.value = parseFloat(bet.value);
      // sendBet.base_line = bet.special_bet_value;
      /* 1UP/2UP synthetic odds: backend expects the BASE odd's _id (so it
         can link the leg via special_market_id) but the SPECIAL/boosted
         odd as `value` — the special odd is what actually gets recorded
         and settled, not the base price. bet.value already holds the
         boosted price for special bets (see MatchCard.jsx/FixtureDetails.jsx),
         so no branching is needed here. */
      const sendBet = {
        _id: bet.is_special_market_odd ? bet.base_odd_id : bet._id,
        value: parseFloat(bet.value),
        base_line: bet.special_bet_value,
        ...(bet.is_special_market_odd && {
          market_type: "special",
          special_market_id: bet.special_market_id,
        }),
        ...(bet.is_live === true && { is_live: 1 }),
      };
      if (typeof bet.is_live === "undefined") {
        live_array.push(null);
      } else {
        live_array.push(bet.is_live);
      }
      return sendBet;
    });

    if (useFreeBet) {
      const minimumMatch = Number(freebetMinimumMatches);
      const minOdds = Number(freebetMinimumOdds);
      const maxOdds = Number(freebetMaximumOdds);

      const hasFewSelections = Bets.length < minimumMatch;
      const numericTotalOdds = Number(totalOdds || 0);

      if (hasFewSelections) {
        setBonusError(
          `Add at least ${minimumMatch} selections to use Free Bet.`,
        );
        return;
      }

      if (numericTotalOdds < minOdds || numericTotalOdds > maxOdds) {
        setBonusError(
          `Total odds must be between ${minOdds} and ${maxOdds} to use Free Bet.`,
        );
        return;
      }
    }

    // if (useFreeBet) {
    //   const minimumMatch = parseInt(minMatch, 10);
    //   const minOdds = parseFloat(minimumOdds);

    //   const hasLowOdd = odds.some((o) => parseFloat(o.value) < minOdds);
    //   const hasFewSelections = Bets.length < minimumMatch;

    //   if (hasFewSelections) {
    //     setBonusError(`Add at least ${minimumMatch} selections to use Free Bet`);
    //     return;
    //   }

    //   if (hasLowOdd) {
    //     setBonusError(`Each selection must have odds of ${minOdds}+`);
    //     return;
    //   }
    // }

    //     if (useFreeBet) {
    //   const hasLowOdd = odds.some((o) => parseFloat(o.value) < 1.5);
    //   if (Bets.length < 5 || hasLowOdd) {
    //    setBonusError(`Required: Min. selection ${minMatch} with ${bonusMinimumOdds}+ odds each`)
    //     return;
    //   }

    // }

    const allEqual = (arr) => arr.every((val) => val === arr[0]);
    // if (!allEqual(live_array)) {
    //   toastr.error(`Live and upcoming bets can’t be combined in one ticket. Please place them separately`);
    //   return;
    // }
    var toWin = _getPossibleWin();

    if (useBonus && parseFloat(toWin) > parseFloat(maximumBonusPayout)) {
      toastr.error(
        `Win Amount Must be less than ${maximumBonusPayout},please remove some of matches`,
      );
      return;
    } else if (parseFloat(toWin) > parseFloat(maximumPayout)) {
      toastr.error(
        `Win Amount Must be less than ${maximumPayout},please remove some of matches`,
      );
      return;
    }
    if (parseFloat(toWin) <= 0) {
      toastr.error(`To Win should be greater than zero`);
      return;
    }
    if (parseFloat(stake) <= 0) {
      toastr.error(`Stake should be greater than zero`);
      return;
    }

    let data = {};
    data.odds = odds;
    data.stake = stake;
    data.accept_odds_change = false;
    data.bonus_amount = selectedBonus != 0 && !useBonus ? selectedBonus : null;
    data.wht = _getPossibleWHT();
    data.to_win = _getPossibleWin();
    data.use_bonus = useBonus;
    data.percentageCurrent = selectedPercent;
    data.is_balance_less = isBalanceLess;
    data.minimum_odds = minimumOdds;
    data.booking_code = bookingId;
    data.useFreeBet = useFreeBet;
    if (allEqual(live_array)) {
      data.is_live = live_array[0] == null ? "0" : "1";
    }
    // data.

    if (mode === "multiple") {
      placeBetCall(data, handleSuccessPlaceBet, handleErrorPlaceBet);
    } else {
      placeSingleBetCall(data, handleSuccessPlaceBet, handleErrorPlaceBet);
    }
  };

  const _handleBookBet = () => {
    setloadingBook(1);
    if (parseFloat(stake) < minimumBet) {
      toastr.error(`Stake should be Greater Or Equal to ${minimumBet}`);
      return;
    } else if (parseFloat(stake) > maximumBet) {
      toastr.error(`Stake should be Less Or Equal to ${maximumBet}`);
      return;
    }
    var live_array = [];
    let odds = Bets.map((bet) => {
      return _getPlacedBet(bet.fixture_markets);
    }).map((bet) => {
      /* 1UP/2UP synthetic odds: backend expects the BASE odd's _id (so it
         can link the leg via special_market_id) but the SPECIAL/boosted
         odd as `value` — the special odd is what actually gets recorded
         and settled, not the base price. bet.value already holds the
         boosted price for special bets (see MatchCard.jsx/FixtureDetails.jsx),
         so no branching is needed here. */
      const sendBet = {
        _id: bet.is_special_market_odd ? bet.base_odd_id : bet._id,
        value: parseFloat(bet.value),
        base_line: bet.special_bet_value,
        ...(bet.is_special_market_odd && {
          market_type: "special",
          special_market_id: bet.special_market_id,
        }),
        ...(bet.is_live === true && { is_live: 1 }),
      };
      if (typeof bet.is_live === "undefined") {
        live_array.push(null);
      } else {
        live_array.push(bet.is_live);
      }
      return sendBet;
    });

    const allEqual = (arr) => arr.every((val) => val === arr[0]);
    // if (!allEqual(live_array)) {
    //   toastr.error(`Live and upcoming bets can’t be combined in one ticket. Please place them separately`);
    //   return;
    // }
    var toWin = _getPossibleWin();
    if (useBonus && parseFloat(toWin) > parseFloat(maximumBonusPayout)) {
      toastr.error(
        `Win Amount Must be less than ${maximumBonusPayout},please remove some of matches`,
      );
      return;
    } else if (parseFloat(toWin) > parseFloat(maximumPayout)) {
      toastr.error(
        `Win Amount Must be less than ${maximumPayout},please remove some of matches`,
      );
      return;
    }
    if (parseFloat(toWin) <= 0) {
      toastr.error(`To Win should be greater than zero`);
      return;
    }
    if (parseFloat(stake) <= 0) {
      toastr.error(`Stake should be greater than zero`);
      return;
    }

    let data = {};
    data.odds = odds;
    data.stake = stake;
    data.accept_odds_change = false;
    data.bonus_amount = selectedBonus != 0 && !useBonus ? selectedBonus : null;
    data.wht = _getPossibleWHT();
    data.to_win = _getPossibleWin();
    data.use_bonus = useBonus;
    data.percentageCurrent = selectedPercent;
    data.is_balance_less = isBalanceLess;
    data.minimum_odds = minimumOdds;
    if (allEqual(live_array)) {
      data.is_live = live_array[0] == null ? "0" : "1";
    }

    // data.
    bookBetCall(data, handleSuccessBookBet, handleErrorBookBet);
  };

  const _submitBet = () => {
    setLoading(1);
    let data = JSON.parse(localStorage.getItem("store_data"));
    localStorage.removeItem("store_data"); //for reducing multiple call
    if (mode === "multiple") {
      placeBetCall(data, handleSuccessPlaceBet, handleErrorPlaceBet);
    } else {
      placeSingleBetCall(data, handleSuccessPlaceBet, handleErrorPlaceBet);
    }
  };
  const handleSuccessBookBet = (response) => {
    let res = response.data.data;
    setNote("");
    setModelOpen(false);

    if (res?.booking_id) {
      let bookDetail = {};
      bookDetail.booking_id = res?.booking_id;
      bookDetail.odds = res?.odds;
      localStorage.setItem("book_bet_detail", JSON.stringify(bookDetail));
    }

    if (res.is_difference) {
      let size = Object.keys(res.odds).length;

      if (!res.is_bonus_used && useBonus) {
        setNote(
          "Required: Min. selection " +
          minMatch +
          "  with " +
          bonusMinimumOdds +
          "+ odds each",
        );
      } else if (
        res.bonus_amount &&
        parseFloat(res.bonus_amount) != parseFloat(selectedBonus)
      ) {
        setNote("Required: Selection  with " + minimumOdds + "+ odds");
      } else if (size < Bets.length) {
        setNote("Some matches or markets have closed");
      }

      setOdds(res.odds);
      setTotalOddNew(res.total_odds);
      setStake(res.stake);
      setWHT(res.wht);
      setMultiBonusPercent(res.percentageCurrent);
      setMultiBonusAmount(res.bonus_amount ? res.bonus_amount : 0);
      setWIN(res.to_win);

      let data = {};
      data.odds = res.odds;
      data.stake = res.stake;
      data.accept_odds_change = res.accept_odds_change;
      data.is_live = res.is_live;
      data.bonus_amount = res.bonus_amount;
      data.wht = res.wht;
      data.to_win = res.to_win;
      data.use_bonus = res.is_bonus_used ? true : false;
      data.percentageCurrent = res.percentageCurrent;
      data.is_balance_less = res.is_balance_less;
      data.minimum_odds = res.minimum_odds;
    } else {
      if (!keepBet) {
        dispatch(setBets([]));
      }
      setCanUseBonus(false);
      setUseBonus(false);
      setBonusAmount(0); //once they use bonus whole bonus balance will be used
      setloadingBook(0);
      setBookModelOpen(true);
      setBookingId(res?.booking_id);
      toastr.success(`Bet Book Successfully`);
    }
  };

  const handleSuccessPlaceBet = (response) => {
    let res = response.data.data ? response.data.data : response.data.success;

    setNote("");
    setModelOpen(false);
    if (response?.data?.error_code == "selection") {
      res?.map((oddsData) => {
        $('[data-id="' + oddsData + '"]').addClass("highlightRemoveClass");
      });
      toastr.error("These markets are close, please remove");
      return;
    }

    if (res.is_difference) {
      let size = Object.keys(res.odds).length;

      if (!res.is_signup_freebet_used && useFreeBet) {
        setNote(
          "Required: Min. selection " +
          minMatch +
          "  with " +
          bonusMinimumOdds +
          "+ odds each",
        );
      } else if (!res.is_bonus_used && useBonus) {
        setNote(
          "Required: Min. selection " +
          minMatch +
          "  with " +
          bonusMinimumOdds +
          "+ odds each",
        );
      } else if (
        res.bonus_amount &&
        parseFloat(res.bonus_amount) != parseFloat(selectedBonus)
      ) {
        setNote("Required: Selection  with " + minimumOdds + "+ odds");
      } else if (size < Bets.length) {
        setNote("Some matches or markets have closed");
      }

      setOdds(res.odds);
      setTotalOddNew(res.total_odds);
      setStake(res.stake);
      setWHT(res.wht);
      setMultiBonusPercent(res.percentageCurrent);
      setMultiBonusAmount(res.bonus_amount ? res.bonus_amount : 0);
      setWIN(res.to_win);

      localStorage.removeItem("store_data");

      let data = {};
      data.odds = res.odds;
      data.stake = res.stake;
      data.accept_odds_change = res.accept_odds_change;
      data.is_live = res.is_live;
      data.bonus_amount = res.bonus_amount;
      data.wht = res.wht;
      data.to_win = res.to_win;
      data.use_bonus = res.is_bonus_used ? true : false;
      data.useFreeBet = res.is_signup_freebet_used ? true : false;
      data.percentageCurrent = res.percentageCurrent;
      data.is_balance_less = res.is_balance_less;
      data.minimum_odds = res.minimum_odds;

      localStorage.setItem("store_data", JSON.stringify(data));
      setModelOpen(true);
    } else {
      if (!keepBet) {
        dispatch(setBets([]));
      }
      setCanUseBonus(false);
      setUseBonus(false);
      bonusType ? setBonusAmount(0) : setSignupBonus(0);
      setLoading(0);
      setshowFreebetMsg(false);
      toastr.success(`Bet Placed Successfully`);

      const event = Array.isArray(res) ? res : [res];

      event.forEach((e) => {
        LocationSDK.reportBetEvent({
          apiKey: ERMC_API_KEY,
          eventDetails: {
            bet_id: String(e.id),
            user_id: String(e.user_id),
            stake_amount: Number(e.stake),
            odds: parseFloat(e.total_odds),
            expected_payout: parseFloat(e.to_win),
          },
          environment: "production",
        });
      });
    }
    localStorage.removeItem("book_bet_detail");
  };

  // When the server rejects on odds movement, pull the corrected odds out of the
  // error payload and reflect them in the slip instead of leaving it stale
  const _applyServerOddsChange = (payload) => {
    if (payload?.error_code !== "odds_changed" || !payload?.data) return false;
    dispatch(
      setBets(
        _applyOddChangesToBets(betsRef.current, _buildOddsMap(payload.data)),
      ),
    );
    setHasAcceptedNewOdds(false);
    toastr.warning(
      payload.ui_message ||
      "Odds changed — review the updated odds and place your bet again.",
    );
    return true;
  };

  const handleErrorPlaceBet = (error, payload) => {
    setNote("");
    setModelOpen(false);
    setLoading(0);
    if (_applyServerOddsChange(payload)) return;
    toastr.error(error);
  };

  const handleErrorBookBet = (error, payload) => {
    setNote("");
    setModelOpen(false);
    setloadingBook(0);
    if (_applyServerOddsChange(payload)) return;
    toastr.error(error);
  };
  const handleSuccessGotUser = (res) => {
    setFirstDeposit(res?.data?.first_deposit);
    setBonusAmount(res?.data?.bonus_balance);
    setSignupBonus(res?.data.signup_freebet);
  };

  const handleEndUserLogSuccess = (res) => {
    setCashLogStatus(res?.status);
  };

  const handleSuccess = (res) => {
    setMinimumOdds(res?.betting_limits?.minimum_odds);
    setIsBonusActive(res?.betting_limits?.is_bonus_active);
    setBonusPercentage(res.multi_bonus?.percentages);
    setMinMatch(res?.betting_limits?.minimum_matches);
    setBonusMinimumOdds(res?.betting_limits?.minimum_odds);
    setStake(parseFloat(res.betting_limits.minimum_bet));
    setMinimumBet(parseFloat(res.betting_limits.minimum_bet));
    setMaximumBet(parseFloat(res.betting_limits.maximum_bet));
    setExciseTaxPercentage(parseFloat(res.regulatory.sales_excise_tax));
    setWHTPercentage(parseFloat(res.regulatory.wht_winning_tax));
    setMaximumPayout(res.betting_limits.maximum_payout);
    setMaximumBonusPayout(res.betting_limits.maximum_bonus_payout);
    setFreebetMinimumOdds(res.betting_limits.free_bet_minimum_odds);
    setFreebetMaximumOdds(res.betting_limits.free_bet_maximum_odds);
    setFreebetMinimumMatches(res.betting_limits.free_bet_minimum_matches);
  };

  useEffect(() => {
    if (searchBookingCode != "" && searchBookingCode != null) {
      axiosApi({
        method: "get",
        url: `/client/get-booked-bet/${searchBookingCode}`,
      })
        .then(function (response) {
          if (Array.isArray(response?.data?.data)) {
            dispatch(setBets(response?.data?.data));
            const betDetails = response?.data?.data;

            let BetOdd = betDetails
              .map((bet) => {
                return _getPlacedBet(bet.fixture_markets);
              })
              .map((bet) => {
                let sendBet = {};
                sendBet._id = bet._id;
                return sendBet;
              });

            let bookDetail = {};
            bookDetail.booking_id = searchBookingCode;
            bookDetail.odds = BetOdd;
            localStorage.setItem("book_bet_detail", JSON.stringify(bookDetail));
          } else {
            showMessage("error", response?.data?.data);
          }
        })
        .catch(function (response) { });
    }
  }, [searchBookingCode]);

  useEffect(() => {
    if (Bets.length) {
      let allOdds = Bets?.map((b) =>
        parseFloat(_getPlacedBet(b.fixture_markets).value),
      );
      let is_live = Bets.map((b) => _getPlacedBet(b.fixture_markets).is_live);
      const allEqual = (arr) => arr.every((val) => val == arr[0]);
      const allEqualPrematch = (arr) =>
        arr.every((val) => val == null || val == false);

      setIsAllPrematch(allEqualPrematch(is_live));

      if (!allEqual(is_live)) {
        setcheckLiveSelected(false);
      }
      const betTypeValue = mode === "single" ? 0 : 1;
      let tempTotalOdds = betTypeValue;
      allOdds.forEach((ao) => {
        if (mode === "multiple") {
          tempTotalOdds = tempTotalOdds * ao;
        } else {
          tempTotalOdds += ao;
        }
      });
      setTotalOdds(tempTotalOdds.toFixed(2));
    } else {
      setTotalOdds(0);
    }
  }, [Bets, mode]);

  // Sync shared stake to the sum of per-selection stakes in Single mode (parity with RN)
  useEffect(() => {
    if (mode === "single") {
      const total = Object.values(singleStakes).reduce(
        (a, b) => a + (Number(b) || 0),
        0,
      );
      setStake(total);
    }
  }, [singleStakes, mode]);

  useEffect(() => {
    if (
      bonusPercentage &&
      Bets.length &&
      isAllPrematch == true &&
      !useBonus &&
      !useFreeBet
    ) {
      var betCount = Bets.length;

      let not_applicable_odds = 0;
      let allOdds = Bets.map((b) =>
        parseFloat(_getPlacedBet(b.fixture_markets).value).toFixed(2),
      );

      if (minimumOdds) {
        allOdds.forEach((ao) => {
          if (parseFloat(ao) < parseFloat(minimumOdds)) {
            not_applicable_odds++;
          }
        });
        setNotApplicableOdds(not_applicable_odds);
      }

      var bonus_bet_count =
        parseFloat(betCount) - parseFloat(not_applicable_odds);
      // percentage
      let percentages = JSON.parse(bonusPercentage);

      if (parseFloat(bonus_bet_count) == 0) {
        setSelectedPercent(0);
      } else {
        let selected = Object.values(percentages).find(
          (e) => e.selection === bonus_bet_count,
        );
        if (!selected) {
          selected = percentages[percentages.length - 1];
        }
        setSelectedPercent(selected.value);
      }

      let currentUser;
      let groupedMessages = [];

      for (const selection of percentages) {
        if (selection.value !== currentUser) {
          groupedMessages.push([]);
          currentUser = selection.value;
        }
        groupedMessages[groupedMessages.length - 1].push(selection);
      }
      let pills = [];
      groupedMessages.forEach((gp) => {
        let from = gp[0].selection;
        let to = gp[gp.length - 1].selection;
        if (![undefined, null, ""].includes(gp[0].value) && from !== to) {
          pills.push({ from: from, to: to, value: gp[0].value });
        } else if (
          ![undefined, null, ""].includes(gp[0].value) &&
          from === to
        ) {
          pills.push({ from: from, value: gp[0].value });
        }
      });
      let does_go = 0;
      pills.map((item, index) => {
        if (item?.to) {
          if (item.from <= bonus_bet_count && item.to >= bonus_bet_count) {
            does_go = 1;
            if (
              typeof pills[index + 1] != "undefined" &&
              pills[index + 1] !== null
            ) {
              var nextRange = pills[index + 1];
              setAddMoreCount(nextRange.from - bonus_bet_count);
              setBonusPercent(nextRange.value);
            }
          }
        }
      });

      if (does_go == 0) {
        var nextRange = pills[1];
        setAddMoreCount(nextRange.from - bonus_bet_count);
        setBonusPercent(nextRange.value);
      }
      if (pills[pills.length - 1]?.from <= bonus_bet_count) {
        setAddMoreCount(null);
        setBonusPercent(null);
      }
      if (pills[pills.length - 1]?.to <= bonus_bet_count) {
        setAddMoreCount(null);
        setBonusPercent(null);
      }
    } else {
      setAddMoreCount(null);
      setBonusPercent(null);
      setSelectedPercent(0);
      setNotApplicableOdds(0);
    }
  }, [bonusPercentage, Bets, useBonus, useFreeBet, isAllPrematch]);

  const _getPlacedBet = (markets) => {
    for (let i = 0; i < markets.length; i++) {
      let odds = markets[i].fixture_market_odds.filter((o) => o?.selected);
      if (odds.length) {
        return odds[0];
      }
    }
  };

  // Static (non-interactive) mini version of the Home/AllSports 1UP/2UP
  // toggle, shown on a betslip row to identify which special market this
  // specific selection uses. `activeId` is 1 (one_up) or 2 (two_up).
  const SpecialMarketBadge = ({ activeId }) => (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 3,
        background: "#0f1923",
        borderRadius: 999,
        padding: 2,
        marginLeft: 4,
        verticalAlign: "middle",
      }}
    >
      {[1, 2].map((id, i) => {
        const active = activeId === id;
        return (
          <React.Fragment key={id}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 18,
                height: 18,
                borderRadius: "50%",
                background: active ? "#FFED00" : "#3a4658",
                color: active ? "#111111" : "#9aa5b8",
                fontSize: 7,
                fontWeight: 800,
                lineHeight: 1,
              }}
            >
              {id}UP
            </span>
            {i === 0 && (
              <span
                style={{
                  width: 3,
                  height: 3,
                  borderRadius: "50%",
                  background: "#ffffff",
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </span>
  );

  const _getMarketName = (markets) => {
    for (let i = 0; i < markets.length; i++) {
      let odds = markets[i].fixture_market_odds.filter((o) => o?.selected);
      if (odds.length) {
        const fm = markets[i];
        const specialLabel = fm.is_special_market
          ? fm.special_market_name === "one_up"
            ? " - 1UP"
            : fm.special_market_name === "two_up"
              ? " - 2UP"
              : ` - ${fm.special_market_name}`
          : "";
        return fm.market.name + specialLabel;
      }
    }
  };
  const _getPossibleWin = () => {
    let stakeAfterTax = stake - exciseTax;
    // var wht = parseFloat(_getPossibleWHT());
    return (stake * parseFloat(totalOdds) + parseFloat(selectedBonus)).toFixed(
      2,
    );
  };

  const _getPossibleWHT = () => {
    let stakeAfterTax = stake - exciseTax;
    let applyTax = stakeAfterTax * totalOdds + parseFloat(selectedBonus);

    let applyPercentWHTOnStakeAfterTax =
      ((applyTax - stakeAfterTax) / 100) * WHTPercentage;
    return applyPercentWHTOnStakeAfterTax.toFixed(2);
  };

  const handleCheckClick = (e) => {
    if (canUseBonus) {
      if (e) {
        setUseBonus(true);
        setOldStake(stake);
        setStake(bonusAmount);
      } else {
        setUseBonus(false);
        setStake(oldStake);
      }
    }
  };

  useEffect(() => {
    setExciseTax((stake / (100 + exciseTaxPercentage)) * exciseTaxPercentage);
  }, [stake, exciseTaxPercentage]);

  useEffect(() => {
    if (Bets.length && isAllPrematch == true) {
      let allOdds = Bets.map((b) =>
        parseFloat(_getPlacedBet(b.fixture_markets).value).toFixed(2),
      );

      let applicable_bet_count = 0;

      if (bonusMinimumOdds == 0) {
        if (Bets.length >= minMatch) {
          setCanUseBonus(true);
        } else {
          setCanUseBonus(false);
        }
      } else if (bonusMinimumOdds) {
        allOdds.forEach((ao) => {
          if (parseFloat(ao) >= parseFloat(bonusMinimumOdds)) {
            applicable_bet_count++;
          }
        });

        if (
          applicable_bet_count == Bets.length &&
          applicable_bet_count >= minMatch
        ) {
          setCanUseBonus(true);
        } else {
          setCanUseBonus(false);
        }
      } else {
        setCanUseBonus(false);
      }
      if (userBalance) {
        if (
          parseFloat(minimumBet) >
          parseFloat(userBalance?.replace(`${currency} `, ""))
        ) {
          setCanUseBonus(true);
          setIsBalanceLess(true);
        }
      } else {
        if (parseFloat(minimumBet) > parseFloat(userBalance)) {
          setCanUseBonus(true);
          setIsBalanceLess(true);
        }
      }
    } else {
      setCanUseBonus(false);
    }
    // setUseBonus(false);
  }, [bonusMinimumOdds, Bets, isAllPrematch, minMatch]);

  useEffect(() => {
    if (selectedPercent && selectedPercent != 0 && !useBonus) {
      // #% Boost = Stake after tax * TotalOdds - 10% [display the 10% value]
      var stakeAfterTax = (stake - exciseTax).toFixed(2);
      var stakeTax = stakeAfterTax * totalOdds;
      var selectPercent = parseFloat(
        (stakeTax * parseFloat(selectedPercent)) / 100,
      );
      setSelectedBonus(selectPercent.toFixed(2));
    } else {
      setSelectedBonus(0);
    }
  }, [selectedPercent, stake, useBonus, totalOdds, exciseTax]);

  // useEffect(() => {
  //   let stakeAfterTax = stake - exciseTax;
  //   var applyTax=0;
  //   if(selectedBonus && selectedBonus!=0) {
  //     applyTax = (stakeAfterTax * totalOdds - stakeAfterTax) + parseFloat(selectedBonus);
  //   }else{
  //     applyTax = stakeAfterTax * totalOdds - stakeAfterTax;
  //   }
  //   let applyPercentWHTOnStakeAfterTax = (applyTax / 100) * WHTPercentage;

  //   setWHT(applyPercentWHTOnStakeAfterTax.toFixed(2));
  // }, [stake, exciseTax, totalOdds, WHTPercentage,selectedBonus]);

  const _renderOddName = (f, odd) => {
    if (odd?.player) {
      return odd?.player?.name;
    }
    let text = odd?.market_spec?.name;
    text = text?.replaceAll("{$competitor1}", f?.competitors[0]?.name);
    text = text?.replaceAll("{$competitor2}", f?.competitors[1]?.name);
    return startCase(text);
  };

  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key]["_id"] === value);
  }

  const _renderBetslips = (can_use_all = 1) => {
    return Bets.map((betslip) => {
      let marketName = _getMarketName(betslip.fixture_markets);
      let selectedOdd = _getPlacedBet(betslip.fixture_markets);
      let can_go = false;
      let make_it_red = false;
      let selectedOddValue = parseFloat(selectedOdd?.value)?.toFixed(2);

      if (can_use_all) {
        can_go = true;
      } else if (odds) {
        let res = JSON.parse(localStorage.getItem("store_data"));
        if (res) {
          Object.keys(odds).forEach((key) => {
            if (odds[key]["_id"] == selectedOdd._id) {
              if (
                ((!res.is_bonus_used && useBonus) ||
                  (res.bonus_amount &&
                    parseFloat(res.bonus_amount) !=
                    parseFloat(selectedBonus))) &&
                odds[key]["value"] != selectedOdd.value
              ) {
                make_it_red = true;
              }
              can_go = true;
              selectedOddValue = parseFloat(
                odds[getKeyByValue(odds, selectedOdd._id)]["value"],
              )?.toFixed(2);
            }
          });
        }
      }
      const isOff =
        isNaN(parseFloat(selectedOdd?.value)) ||
        selectedOdd?.active === 0 ||
        selectedOdd?.active === "0";
      const isInactive = !can_go || make_it_red || isOff;
      return (
        <div
          key={betslip._id}
          data-id={selectedOdd._id}
          style={{
            display: "flex",
            alignItems: "flex-start",
            background: "#101A26",
            borderBottom: "1px solid #1A2433",
            padding: "12px 8px",
            opacity: isOff ? 0.5 : 1,
          }}
        >
          {can_use_all ? (
            <div
              style={{
                justifyContent: "center",
                paddingLeft: 4,
                paddingRight: 8,
                paddingTop: 1,
                cursor: "pointer",
              }}
              onClick={() => {
                dispatch(setBets(Bets.filter((b) => b._id != betslip._id)));
              }}
            >
              <span
                style={{ fontSize: 13, color: "#8B96A8", lineHeight: "14px" }}
              >
                ✕
              </span>
            </div>
          ) : null}
          <div style={{ flex: 1, alignSelf: "stretch" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  paddingRight: 10,
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    width: 16,
                    height: 16,
                    flexShrink: 0,
                    borderRadius: 2,
                    background: "#172131",
                    border: "1px solid #2A3544",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span
                    style={{
                      fontSize: 9,
                      lineHeight: "10px",
                      color: "#A7B0C0",
                    }}
                  >
                    ⚽
                  </span>
                </div>
                <div
                  style={{
                    flex: 1,
                    fontWeight: 700,
                    color: "#FFFFFF",
                    fontSize: 14,
                    lineHeight: "18px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {_renderOddName(betslip, selectedOdd)}
                  {selectedOdd?.special_bet_value
                    ? ` [${selectedOdd.special_bet_value}]`
                    : ""}
                </div>
              </div>

              <div
                style={{
                  alignItems: "flex-end",
                  minWidth: 60,
                  paddingLeft: 6,
                  textAlign: "right",
                }}
              >
                <div
                  style={{
                    fontWeight: 800,
                    color: isInactive ? "#FF4D4F" : "#F5D90A",
                    fontSize: 16,
                    lineHeight: "18px",
                  }}
                >
                  {isOff ? "OFF" : selectedOddValue}
                </div>
                {!isInactive && selectedOdd?.oddChange === "up" && (
                  <div
                    style={{
                      color: "#39D353",
                      fontSize: 10,
                      marginTop: -2,
                      fontWeight: 700,
                    }}
                  >
                    ▲ +
                    {(
                      parseFloat(selectedOdd.value) -
                      (selectedOdd.prevValue ?? parseFloat(selectedOdd.value))
                    ).toFixed(2)}
                  </div>
                )}
                {!isInactive && selectedOdd?.oddChange === "down" && (
                  <div
                    style={{
                      color: "#FF6B6B",
                      fontSize: 10,
                      marginTop: -2,
                      fontWeight: 700,
                    }}
                  >
                    ▼{" "}
                    {(
                      parseFloat(selectedOdd.value) -
                      (selectedOdd.prevValue ?? parseFloat(selectedOdd.value))
                    ).toFixed(2)}
                  </div>
                )}
                {isInactive && (
                  <div
                    style={{
                      fontSize: 9,
                      color: "#FF6B6B",
                      marginTop: 1,
                      fontWeight: 700,
                    }}
                  >
                    Unavailable
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                fontSize: 13,
                color: "#B9C3D3",
                marginTop: 2,
                lineHeight: "16px",
                fontWeight: 700,
              }}
            >
              {betslip?.competitors?.[0]?.name ?? "-"} vs{" "}
              {betslip?.competitors?.[1]?.name ?? "-"}
            </div>
            <div
              style={{
                fontSize: 12,
                color: "#8B96A8",
                marginTop: 4,
                lineHeight: "14px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span>
                {marketName}
                {betslip?.tournament?.name
                  ? ` - ${betslip.tournament.name}`
                  : ""}
              </span>
              {selectedOdd?.is_special_market_odd && (
                <SpecialMarketBadge activeId={selectedOdd.special_market_id} />
              )}
            </div>

            {mode === "single" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 10,
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1.5px solid #C9B700",
                    borderRadius: 8,
                    background: "#000000",
                    padding: "8px 12px",
                    minWidth: 130,
                  }}
                >
                  <span
                    style={{
                      fontSize: 14,
                      color: "#7E8A97",
                      fontWeight: 700,
                      marginRight: 10,
                    }}
                  >
                    {currencySymbol}
                  </span>
                  <input
                    type="number"
                    value={singleStakes[betslip._id] ?? ""}
                    onChange={(e) =>
                      setSingleStakes((prev) => ({
                        ...prev,
                        [betslip._id]: parseFloat(e.target.value) || 0,
                      }))
                    }
                    placeholder="0"
                    style={{
                      width: 60,
                      background: "transparent",
                      border: "none",
                      color: "#FFD400",
                      fontSize: 20,
                      fontWeight: 800,
                      outline: "none",
                    }}
                  />
                </div>
                <div style={{ fontSize: 12, color: "#B9C3D3" }}>
                  Returns{" "}
                  <span style={{ color: "#fff", fontWeight: 700 }}>
                    {currencySymbol}
                    {Math.round(
                      (singleStakes[betslip._id] ?? 0) *
                      (isOff ? 0 : parseFloat(selectedOddValue) || 0),
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  // A polled odds change in the direction the user hasn't agreed to accept
  // requires an explicit "Accept New Odds" tap before placing (parity with mobile)
  const hasBlockedOddsChange =
    !hasAcceptedNewOdds &&
    Bets.some((b) => {
      const sel = _getPlacedBet(b.fixture_markets);
      if (oddsAcceptMode === "higher") return sel?.oddChange === "down";
      return sel?.oddChange === "up";
    });

  const hasAnyOddChange = Bets.some((b) => {
    const sel = _getPlacedBet(b.fixture_markets);
    return sel?.oddChange === "up" || sel?.oddChange === "down";
  });

  return (
    <>
      <div
        className="main-body"
        style={{ background: "#0f1923", minHeight: "100vh" }}
      >
        <div className="w-100 h-100" style={{ background: "#0f1923" }}>
          <div
            className="BLM-rightMenu-main-content"
            style={{ background: "#0f1923" }}
          >
            <div className="">
              {/* RN HomeHeader (onBack variant): yellow bar, back arrow + title only —
                  no persistent balance/deposit/booking-search clutter in the header itself */}
              <div
                style={{
                  background: "#FFED00",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "16px 16px 14px",
                }}
              >
                <div
                  onClick={() => {
                    props.history.push("/sports");
                  }}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 16,
                    background: "rgba(0,0,0,0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 32 32" fill="none">
                    <path
                      d="M18 20L14 16L18 12"
                      stroke="#111111"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <span
                  style={{ color: "#111112", fontSize: 17, fontWeight: 800 }}
                >
                  Betslip
                </span>
              </div>

              {Bets.length > 1 && (
                <div
                  style={{
                    display: "flex",
                    background: "#273246",
                    borderRadius: 4,
                    overflow: "hidden",
                  }}
                >
                  {[
                    ["single", "Single"],
                    ["multiple", "Multi"],
                  ].map(([value, label]) => (
                    <button
                      key={value}
                      onClick={() => setMode(value)}
                      style={{
                        flex: 1,
                        textAlign: "center",
                        padding: "11px 0",
                        background: mode === value ? "#1D2636" : "#273246",
                        color: mode === value ? "#FFFFFF" : "#7C8799",
                        fontWeight: 700,
                        fontSize: 14,
                        border: "none",
                        borderBottom:
                          mode === value
                            ? "3px solid #FFED00"
                            : "3px solid transparent",
                        cursor: "pointer",
                      }}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              )}
              <>
                {Bets.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "15px 8px 15px 20px",
                      background: "#101A26",
                      borderBottom: "1px solid #1A2433",
                    }}
                  >
                    <div
                      onClick={() => {
                        dispatch(setBets([]));
                        setBookingId(null);
                        setSearchBookingCode(null);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                        cursor: "pointer",
                      }}
                    >
                      <span
                        style={{
                          color: "#98A2B3",
                          fontSize: 12,
                          lineHeight: "13px",
                        }}
                      >
                        ✕
                      </span>
                      <span
                        style={{
                          color: "#98A2B3",
                          fontSize: 14,
                          fontWeight: 600,
                        }}
                      >
                        Remove All
                      </span>
                    </div>

                    <div
                      style={{
                        width: 1,
                        height: 14,
                        background: "#3A4350",
                        margin: "0 12px",
                      }}
                    />
                    <span
                      style={{
                        color: "#98A2B3",
                        fontSize: 14,
                        fontWeight: 600,
                        marginRight: 8,
                      }}
                    >
                      Accept
                    </span>
                    <select
                      value={oddsAcceptMode}
                      onChange={(e) => {
                        setOddsAcceptMode(e.target.value);
                        setHasAcceptedNewOdds(false);
                      }}
                      aria-label="Which odds changes to accept automatically"
                      style={{
                        fontSize: 13,
                        fontWeight: 500,
                        background: "#1D2636",
                        color: "#fff",
                        border: "1px solid #2E3A4A",
                        borderRadius: 6,
                        padding: "6px 12px",
                      }}
                    >
                      <option value="higher">Higher only</option>
                      <option value="lower">Lower only</option>
                    </select>
                  </div>
                )}

                {hasAnyOddChange && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "6px 8px 0",
                      padding: "12px",
                      borderLeft: "3px solid #F5A623",
                      borderRadius: 4,
                      background: "#2C2A24",
                    }}
                  >
                    <div
                      style={{
                        width: 18,
                        height: 18,
                        flexShrink: 0,
                        borderRadius: 9,
                        border: "1px solid #F5A623",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 10,
                      }}
                    >
                      <span
                        style={{
                          color: "#F5A623",
                          fontSize: 11,
                          fontWeight: 700,
                          lineHeight: "12px",
                        }}
                      >
                        i
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        color: "#F4E7C2",
                        lineHeight: "19px",
                      }}
                    >
                      <span style={{ color: "#F5A623", fontWeight: 700 }}>
                        Some odds changed since you added them.
                      </span>{" "}
                      Accept set to{" "}
                      <span style={{ color: "#F5A623", fontWeight: 700 }}>
                        {oddsAcceptMode === "higher" ? "higher" : "lower"}
                      </span>
                      .
                    </div>
                  </div>
                )}

                <div
                  className="BLM-betSlip-content"
                  style={{ overflowY: "scroll", background: "#101A26" }}
                >
                  <div className="main-slip-st">{_renderBetslips(1)}</div>

                  {Bets.length === 0 && (
                    <div
                      style={{
                        minHeight: "calc(100vh - 260px)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0 16px",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}
                      >
                        Your betslip is empty
                      </div>
                      <div
                        style={{ fontSize: 13, color: "#8B96A8", marginTop: 6 }}
                      >
                        Add selections from any match to get started.
                      </div>
                      <button
                        onClick={() => setBookingSheetOpen(true)}
                        style={{
                          marginTop: 16,
                          background: "transparent",
                          color: "#FFED00",
                          fontWeight: 700,
                          fontSize: 13,
                          border: "1px solid #252838",
                          borderRadius: 8,
                          padding: "9px 16px",
                          cursor: "pointer",
                        }}
                      >
                        Load booking code
                      </button>
                    </div>
                  )}
                </div>
              </>
              {
                <div className="row img_row">
                  <ReactModal isOpen={openModel} style={customStyles}>
                    <div>
                      <div>
                        <div className="modalHeader ">
                          BetSlip Confirmation{" "}
                        </div>
                      </div>
                      <div
                        className="BLM-betSlip-content"
                        style={{ overflowY: "auto", height: "45vh" }}
                      >
                        <div className="pl-2 main-slip-st">
                          {_renderBetslips(0)}
                        </div>
                      </div>
                      <div className="BLM-betSlip-footer">
                        {note ? (
                          <div
                            className="BLM-addSelections-infoMsg"
                            id="betInfoMsg"
                          >
                            {" "}
                            <a href="/" className="text-danger">
                              {note}
                            </a>
                          </div>
                        ) : null}
                        <div className="BLM-totalStakeOddsWins">
                          <div
                            className="BLM-accordion"
                            id="getBetslipAccordianId"
                          >
                            <div className="BLM-accordion-header BLM-BetslipArrowAfter">
                              <div className="BLM-totalStakeOddsWins-content">
                                <div className="BLM-contentBlock font-cls">
                                  <div className="BLM-leftContent">
                                    Total Odds:
                                  </div>
                                  <div className="BLM-rightContent">
                                    {totalOddNew}
                                  </div>
                                </div>
                                <div className="BLM-contentBlock BLM-wht font-cls">
                                  <div className="BLM-leftContent">
                                    Stake after tax:
                                  </div>
                                  <div
                                    className="BLM-rightContent"
                                    id="bindDeductedStakeValue"
                                  >
                                    {currency} {(stake - exciseTax).toFixed(2)}
                                  </div>
                                </div>
                                <div className="BLM-contentBlock BLM-wht font-cls">
                                  <div className="BLM-leftContent">
                                    Excise Tax:
                                  </div>
                                  <div
                                    className="BLM-rightContent"
                                    id="bindExciseValue"
                                  >
                                    {currency} {exciseTax.toFixed(2)}
                                  </div>
                                </div>
                                <div className="BLM-contentBlock BLM-wht font-cls">
                                  <div className="BLM-leftContent">WHT:</div>
                                  <div
                                    className="BLM-rightContent"
                                    id="bindTaxValue"
                                  >
                                    {currency} {WHT}
                                  </div>
                                </div>
                                {multiBonusPercent && multiBonusPercent != 0 ? (
                                  <div className="BLM-contentBlock">
                                    <div className="BLM-leftContent BLM-txtHighlight font-cls">
                                      {multiBonusPercent}% Boost:
                                    </div>
                                    <div
                                      className="BLM-rightContent BLM-txtHighlight font-cls"
                                      id="bindWinningValue"
                                    >
                                      {currency} {multiBonusAmount}
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                <div className="BLM-contentBlock">
                                  <div className="BLM-leftContent BLM-txtHighlight font-cls">
                                    To Win:
                                  </div>
                                  <div
                                    className="BLM-rightContent BLM-txtHighlight font-cls"
                                    id="bindWinningValue"
                                  >
                                    {currency} {WIN}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <CountDown seconds={15} />
                        </div>
                        <p
                          style={{
                            fontSize: "10px",
                            color: "red",
                            marginTop: "10px",
                          }}
                        >
                          By pressing “Bet Confirmation” you accept the above
                          choices, or let timer run out to change
                        </p>
                        <div>
                          <button
                            className="btn BLM-btnPrimary active"
                            onClick={() => {
                              _submitBet();
                            }}
                            style={{
                              height: "35px",
                              fontSize: "12px",
                              marginTop: "7px",
                            }}
                          >
                            Bet Confirmation
                          </button>
                        </div>
                      </div>
                    </div>
                  </ReactModal>
                </div>
              }
              {
                <div className="row img_row">
                  <ReactModal isOpen={openBookModel} style={customBetStyles}>
                    <div className="modal-content  book-a-bet-div">
                      {/* <div className="modal-header">
                          <div className="modal-title h4">SHARE BET</div>
                          <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={()=> {
                            setBookModelOpen(false)
                          }}></button>
                        </div> */}
                      <div className="modal-body">
                        {/* <center><p style={{fontSize:"17px"}}>You can place the booked bet in a betslip or share it with a friend.</p></center> */}

                        <div className="code-div !text-[var(--bet-betyakata-header)]">
                          <p style={{ fontSize: "17px" }}>
                            Booking Code has successfully been generated. Your
                            code is
                          </p>
                          <h4>{bookingId}</h4>

                          <p className="copy-code">
                            <a
                              href="javascript:void(0)"
                              style={{ textDecoration: "underline" }}
                              onClick={() => {
                                copied();
                              }}
                            >
                              COPY BOOKING CODE
                            </a>{" "}
                            <span className="apply-p1"></span>
                          </p>
                          <Whatsapp
                            solid
                            small
                            message={`Booked Ticket - Great Winnings, just visit Domain and enter Booking Code: ${bookingId} on Betslip.`}
                            link={bburl}
                          />
                          <Telegram
                            solid
                            small
                            text={`Booked Ticket - Great Winnings, just visit Domain and enter Booking Code: ${bookingId} on Betslip.`}
                            link={bburl}
                          />
                          <Facebook
                            solid
                            small
                            quote={`Booked Ticket - Great Winnings, just visit Domain and enter Booking Code: ${bookingId} on Betslip.`}
                            link={bburl}
                          />
                          <Twitter
                            solid
                            small
                            message={`Booked Ticket - Great Winnings, just visit Domain and enter Booking Code: ${bookingId} on Betslip.`}
                            link={bburl}
                          />
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary btn-new-bet !bg-[var(--bet-betyakata-header)]"
                          onClick={(e) => setBookModelOpen(false)}
                        >
                          CLOSE
                        </button>
                      </div>
                    </div>
                  </ReactModal>
                </div>
              }
              {/* --------------------------- footer --------------------------- */}
              {/* Stake/summary/action UI is irrelevant with nothing staked —
                  keep the empty state as a clean standalone screen */}
              {Bets.length > 0 && (
                <div
                  className="BLM-betSlip-footer"
                  style={{ background: "#101A26" }}
                >
                  {freebet > 0 && showFreebetMsg && (
                    <div
                      onClick={() => {
                        if (useFreeBet) {
                          setuseFreeBet(false);
                          setUseBonus(false);
                        } else if (Bets.length >= minMatch) {
                          setStake(freebet);
                          setuseFreeBet(true);
                          setUseBonus(false);
                        } else {
                          toastr.error(
                            `Add at least ${minMatch} selections to use Free Bet`,
                          );
                        }
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: "12px 8px 8px",
                        padding: "12px",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          width: 36,
                          height: 36,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: 10,
                          flexShrink: 0,
                        }}
                      >
                        <span style={{ fontSize: 24 }}>🎁</span>
                      </div>
                      <div style={{ flex: 1 }}>
                        <span
                          style={{
                            color: "#FFFFFF",
                            fontSize: 14,
                            fontWeight: 600,
                            lineHeight: "18px",
                          }}
                        >
                          Free bet — {currencySymbol}
                          {Number(freebet).toLocaleString()} available
                        </span>
                      </div>
                      <div
                        style={{
                          width: 48,
                          height: 28,
                          borderRadius: 14,
                          background: useFreeBet ? "#4A7C59" : "#3A4556",
                          display: "flex",
                          alignItems: "center",
                          padding: 2,
                          marginLeft: 12,
                          flexShrink: 0,
                        }}
                      >
                        <div
                          style={{
                            width: 24,
                            height: 24,
                            borderRadius: 12,
                            background: "#FFFFFF",
                            marginLeft: useFreeBet ? "auto" : 0,
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {isAllPrematch == false ? (
                    <p
                      style={{
                        color: "red",
                        fontSize: 12,
                        marginTop: 4,
                        padding: "0 8px",
                      }}
                    >
                      Please remove live matches to get Bonus
                    </p>
                  ) : addMoreCount && bonusPercent ? (
                    <div
                      id="betInfoMsg"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: "10px 8px 2px",
                        padding: "12px",
                        borderRadius: 8,
                        border: "1px solid #37306D",
                        background: "#1B2140",
                      }}
                    >
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          flexShrink: 0,
                          borderRadius: 14,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#6B4BFF",
                          marginRight: 10,
                          color: "#fff",
                          fontSize: 18,
                          fontWeight: 800,
                        }}
                      >
                        +
                      </div>
                      <div>
                        <div
                          style={{
                            color: "#fff",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          Boost your slip
                        </div>
                        <div
                          style={{
                            color: "#A8B0D0",
                            fontSize: 12,
                            marginTop: 1,
                          }}
                        >
                          Add {addMoreCount} more leg
                          {addMoreCount === 1 ? "" : "s"} for{" "}
                          <span style={{ color: "#FFD400", fontWeight: 800 }}>
                            +{bonusPercent}% multi bonus
                          </span>
                        </div>
                      </div>
                      {notApplicableOdds > 0 ? (
                        <button
                          style={{ background: "#ebefff", border: "none" }}
                          title={`All selections value should be greater than  ${minimumOdds} to receive a bonus`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-exclamation-circle-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                          </svg>
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="BLM-stakeBox-container">
                    {(() => {
                      const shouldShowBonusCheckbox =
                        (firstDeposit === 0 ||
                          (isBalanceLess && cashLogStatus)) &&
                        Bets.length > 0 &&
                        (parseFloat(bonusAmount) > 0 ||
                          parseFloat(signupBonus) > 0) &&
                        isBonusActive &&
                        isAllPrematch;

                      if (!shouldShowBonusCheckbox) return null;

                      return (
                        <div
                          style={{
                            marginTop: 8,
                            padding: "0 8px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 8,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                            }}
                          >
                            {bonusAmount && (
                              <div
                                onClick={() =>
                                  canUseBonus && handleCheckClick(!useBonus)
                                }
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 6,
                                  cursor: canUseBonus ? "pointer" : "default",
                                  opacity: !canUseBonus ? 0.5 : 1,
                                }}
                                title={`Required: Min. selection ${minMatch} with ${bonusMinimumOdds}+ odds each`}
                              >
                                <div
                                  style={{
                                    width: 18,
                                    height: 18,
                                    borderRadius: 3,
                                    border: `1.5px solid ${useBonus ? "#FFED00" : "#8b8fa8"}`,
                                    background: useBonus
                                      ? "#FFED00"
                                      : "transparent",
                                    flexShrink: 0,
                                  }}
                                />
                                <span style={{ color: "#fff", fontSize: 13 }}>
                                  Use Bonus Amount
                                </span>
                              </div>
                            )}
                          </div>
                          {bonusError && (
                            <p className="text-red-500 text-[10px] mt-1">
                              {bonusError}
                            </p>
                          )}
                        </div>
                      );
                    })()}
                    <div className="BLM-freeBet" />
                    <div id="displayStakeBox">
                      <div className="BLM-stakeInputBox BLM-form-control">
                        {" "}
                        <span className="font-cls p-2">{currency}</span>
                        <input
                          type="number"
                          className="w-50"
                          placeholder="Stake"
                          id="stakeValue"
                          disabled={useBonus}
                          value={stake}
                          style={{
                            opacity: useBonus ? ".65" : "1",
                            pointerEvents: useBonus ? "none" : "auto",
                          }}
                          onChange={(e) => {
                            setStake(e.target.value);
                          }}
                        />
                        <i className="sb-icon_close BLM-closeIcon p-2" />
                      </div>
                    </div>
                    <div id="displayFreeBetDropDown" />
                  </div>
                  {/* RN BetSlipScreen quick-add stake chips: add to current stake, clamped to maximumBet */}
                  {!useBonus && (
                    <div className="byk-stake-quick-row">
                      {QUICK_STAKES.map((amount) => (
                        <button
                          key={amount}
                          className="byk-stake-quick-btn"
                          onClick={() =>
                            setStake((prev) => {
                              const next = Number(prev || 0) + amount;
                              return String(
                                maximumBet != null
                                  ? Math.min(next, maximumBet)
                                  : next,
                              );
                            })
                          }
                        >
                          +{amount.toLocaleString()}
                        </button>
                      ))}
                      <button
                        className="byk-stake-quick-btn byk-stake-max"
                        onClick={() => {
                          if (maximumBet != null) {
                            setStake(String(maximumBet));
                            return;
                          }
                          const bal = parseFloat(
                            String(userBalance).replace(/[^\d.]/g, ""),
                          );
                          if (!isNaN(bal) && bal > 0) setStake(String(bal));
                        }}
                      >
                        Max
                      </button>
                    </div>
                  )}
                  <div
                    style={{
                      marginTop: 16,
                      padding: "12px 8px 0",
                      borderTop: "1px solid #1A2433",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 2,
                        paddingBottom: 2,
                      }}
                    >
                      <span
                        style={{
                          color: "#5A7A9A",
                          fontSize: 11,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Selections
                      </span>
                      <span
                        style={{
                          color: "#FFFFFF",
                          fontSize: 13,
                          fontWeight: 700,
                        }}
                      >
                        {Bets.length} OF {Bets.length} ACTIVE
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 2,
                        paddingBottom: 2,
                      }}
                    >
                      <span
                        style={{
                          color: "#5A7A9A",
                          fontSize: 11,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Total Odds
                      </span>
                      <span
                        style={{
                          color: "#FFFFFF",
                          fontSize: 13,
                          fontWeight: 700,
                        }}
                      >
                        {totalOdds}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 2,
                        paddingBottom: 2,
                      }}
                    >
                      <span
                        style={{
                          color: "#5A7A9A",
                          fontSize: 11,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Stake
                      </span>
                      <span
                        style={{
                          color: "#FFFFFF",
                          fontSize: 13,
                          fontWeight: 700,
                        }}
                      >
                        {currencySymbol}
                        {Number(stake || 0).toLocaleString()}
                      </span>
                    </div>
                    {selectedPercent > 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: 6,
                          paddingBottom: 6,
                          borderBottom: "1px solid #1A2433",
                        }}
                      >
                        <span
                          style={{
                            color: "#5A7A9A",
                            fontSize: 11,
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                          }}
                        >
                          Multi Bonus
                        </span>
                        <span
                          style={{
                            color: "#39D353",
                            fontSize: 13,
                            fontWeight: 800,
                          }}
                        >
                          +{selectedPercent}%
                        </span>
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          color: "#5A7A9A",
                          fontSize: 11,
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Potential Win
                      </span>
                      <span
                        style={{
                          color: "#FFD400",
                          fontSize: 20,
                          fontWeight: 800,
                        }}
                      >
                        {currencySymbol}
                        {Number(_getPossibleWin()).toLocaleString()}
                      </span>
                    </div>
                  </div>

                  <div
                    style={{ display: "flex", gap: 8, padding: "8px 8px 0" }}
                  >
                    {loading != null && loading == 1 ? (
                      <div
                        style={{
                          flex: 1,
                          background: "#4A5260",
                          minHeight: 52,
                          borderRadius: 8,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          className="spinner-grow spinner-grow-sm"
                          style={{ color: "#fff" }}
                        ></span>
                      </div>
                    ) : (
                      <button
                        onClick={() => {
                          if (hasBlockedOddsChange) {
                            setHasAcceptedNewOdds(true);
                            setOddsAcceptMode("higher");
                          } else {
                            setHasAcceptedNewOdds(false);
                            _handleSubmitBet();
                          }
                        }}
                        style={{
                          flex: 1,
                          background: hasBlockedOddsChange
                            ? "#f59e0b"
                            : "#4A5260",
                          color: hasBlockedOddsChange ? "#111" : "#fff",
                          minHeight: 52,
                          borderRadius: 8,
                          border: "none",
                          fontWeight: 700,
                          fontSize: 12,
                          letterSpacing: "1.5px",
                          textTransform: "uppercase",
                          cursor: "pointer",
                        }}
                      >
                        {hasBlockedOddsChange ? "Accept new odds" : "Place Bet"}
                      </button>
                    )}
                    {loadingBook != null && loadingBook == 1 ? (
                      <div
                        style={{
                          flex: 1,
                          background: "#FFED00",
                          minHeight: 52,
                          borderRadius: 8,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span
                          className="spinner-grow spinner-grow-sm"
                          style={{ color: "#000" }}
                        ></span>
                      </div>
                    ) : (
                      <button
                        onClick={() => {
                          _handleBookBet();
                        }}
                        style={{
                          flex: 1,
                          background: "#FFED00",
                          color: "#111",
                          minHeight: 52,
                          borderRadius: 8,
                          border: "none",
                          fontWeight: 700,
                          fontSize: 12,
                          letterSpacing: "1.5px",
                          textTransform: "uppercase",
                          cursor: "pointer",
                        }}
                      >
                        Book Bet
                      </button>
                    )}
                  </div>

                  <div
                    style={{ padding: "12px 8px 24px", textAlign: "center" }}
                  >
                    <span
                      style={{ color: "rgba(255,255,255,0.35)", fontSize: 11 }}
                    >
                      Min {currencySymbol}
                      {minimumBet != null
                        ? Number(minimumBet).toLocaleString()
                        : "20"}{" "}
                      · Max {currencySymbol}
                      {maximumBet != null
                        ? Number(maximumBet).toLocaleString()
                        : "500,000"}{" "}
                      · NLRC Licensed · 18+
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <BookingCodeSheet
        isOpen={bookingSheetOpen}
        onClose={() => setBookingSheetOpen(false)}
      />
    </>
  );
}

export default withRouter(BetSlip);
